module.exports = {
	"LANGUAGE": "Lingua",
	"HDR-obpa_fulltext_score": "Classificazione",
	"HDR-obpa_name": "Nome",
	"HDR-obpa_fulltext_summary": "Sommario",
	"QUERY LIMIT REACHED": "Ci sono più risultati di quelli visualizzati. Si prega di restringere i criteri di ricerca.",
	"NO DOCUMENTS FOUND": "Nessun documento trovato.",
	"OPEN IN NEW WINDOW": "Apri in una nuova finestra",
	"DOWNLOAD NATIVE": "Scarica in formato nativo",
	"CLOSE": "Chiudere",
	"SEARCH TYPE": "Tipo di ricerca",
	"DOCUMENT TYPE": "Tipo di documento",
	"SEARCH TERM": "Termine di ricerca",
	"SEARCH": "Ricerca",
	"RESET": "Reset",
	"DATE": "Data",
	"FROM DATE": "Da Data",
	"TO DATE": "Fino ad oggi",
	"LOADING": "In caricamento...",
	"RETRY": "Riprovare",
	"ERROR": "Errore!",
	"ERROR: QUERIES": "Impossibile recuperare l'elenco dei tipi di ricerca.",
	"ERROR: DOCTYPES": "Impossibile recuperare l'elenco dei tipi di documento.",
	"ERROR: KEYWORDS": "Impossibile recuperare l'elenco dei campi di ricerca.",
	"ERROR: DOCUMENTS": "Impossibile eseguire la ricerca richiesta.",
	"FORM: INVALID FULLTEXT": "Il campo deve contenere almeno {{chars}} caratteri.",
	"FORM: INVALID DATE SHORT": "Formato: {{format}} .",
	"FORM: REQUIRED KEYWORD": "Il campo è obbligatorio.",
	"FORM: INVALID NUMERIC": "Il campo deve essere un numero fino a {{digits}} cifre.",
	"FORM: INVALID DATE": "Il campo deve seguire il formato {{format}} .",
	"FORM: INVALID CURRENCY": "Il campo deve essere un valore di valuta valido.",
	"FORM: INVALID FLOAT": "Il campo deve essere un numero.",
	"FORM: INVALID LENGTH": "Il campo deve contenere al massimo  {{chars}} caratteri.",
	"FORM: ERRORS": "Ci sono errori sul modulo.",
	"FORM: noDate": "Deve essere specificato un intervallo di date.",
	"FORM: noKeyword": "Deve essere specificato almeno un campo.",
	"FORM: noDateOrKeyword": "Un intervallo di date OPPURE deve essere specificato almeno un campo.",
	"FORM: noDateAndKeyword": "È necessario specificare un intervallo di date E almeno un campo."
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/it.json
// module id = 355
// module chunks = 0